'use strict';
angular.module("textAngularToolbarPlugin", ['textAngular'])
  .config(['$provide', function ($provide) {
    // this demonstrates how to register a new tool and add it to the default toolbar
    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) { // $delegate is the taOptions we are decorating
      taRegisterTool('save', {
        iconclass: "fa fa-floppy-o",
        action: function () {
          this.$editor().$root.$broadcast("resource-translation-editor-save-triggered", {});
        }
      });
      // add the button to the default toolbar definition
      taOptions.toolbar[1].push('save');
      return taOptions;
    }]);
  }]);
